<template>
  <div v-if="!submitted" class="panel-simple">
    <div v-if="!editing">
      <div class="panel-row-without-selector mb-4 pb-4">
        <div class="col-md-12 col-sm-12 text-center mt-3">
          <button
            id="btnFA"
            class="btn bg-light-white w-75 pt-1"
            @click="enableEditing"
            v-if="canShowSave"
          >
            <em class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aqu&iacute; para anejar documento
            </span>
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="panel-row-without-selector subtitle">
        <div class="tag-badge-referred">
          <span class="dot-info-rev">
            <em class="fas fa-plus orange-icon" />
          </span>
          <span v-show="!document.Id" class="tag-badge-title-info">
            A&ntilde;adir Documento
          </span>
          <span v-show="document.Id" class="tag-badge-title-info">
            Editar Documento
          </span>
        </div>
      </div>

      <div class="container-fluid bg-rectangle-gradiant" />

      <ValidationObserver ref="observer" novalidate>
        <div class="panel-row-without-selector text-left pb-3">
          <div class="row">
            <div v-if="isVisible('Fecha')" class="col-md-md-2 col-sm-12">
              <p class="p-title">
                <strong>Fecha</strong>
              </p>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDatePicker
                  v-model="document.date"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs.date"
                  :max-date="new Date()"
                  class="custom-datetime-picker-container custom-datetime-picker-container-grey"
                />
              </ValidationProvider>
              <span v-if="showMessageDate" class="danger-text" />
            </div>
            <div
              v-if="isVisible('Tipo')"
              class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2"
            >
              <p class="p-title">
                <strong>Tipo</strong>
              </p>
              <select
                ref="typeSelected"
                v-model="document.documentTypeId"
                class="control-input w-100"
                @change="checkValidation"
              >
                <option value="0">
                  Seleccione
                </option>
                <option v-for="type in types" :key="type.name" :value="type.id">
                  {{ type.name }}
                </option>
              </select>
              <span v-if="showMessageDocumentType" class="danger-text">
                Favor de seleccionar el tipo de documento.
              </span>
            </div>
            <div
              v-if="isVisible('Titulo')"
              class="col-md-7 col-sm-12 mt-2 mt-md-0 mt-sm-2"
            >
              <p class="p-title">
                <strong>Documento</strong>
              </p>
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="Documento"
                rules="required"
              >
                <CustomFileInput
                  ref="fileUpload2"
                  v-model="document.attachment"
                  :attachment-id="document.Id"
                  :accept="allowedFiles"
                  :value="document.attachment"
                  required
                  :error="errors[0]"
                  :name="document.name"
                  :custom-error-msg="errorMsgs.document"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div
          v-if="isVisible('Comentario')"
          class="panel-row-without-selector text-left mb-5 pb-4"
        >
          <div class="row w-100">
            <div class="col-md-12 col-sm-12">
              <p class="p-title">
                <strong>Añadir Comentario</strong>
              </p>
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="Comentario"
                rules="required"
              >
                <CustomTextArea
                  id="comment"
                  v-model="document.comment"
                  :maxlength="commentMaxLength"
                  :classes="['eq-field']"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs.comment"
                  name="comment"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="d-flex flex-row-reverse bd-highlight w-100 mb-5 actions">
          <div class="mx-0 bd-highlight ml-2">
            <ActionButton variant="success" i="fas fa-file-plus" @click="save">
              {{ !document.Id ? 'Añadir' : 'Guardar' }}
            </ActionButton>
          </div>
          <div class="mx-0 bd-highlight ml-2">
            <ActionButton
              id="modal-btn-cancelar"
              variant="outline-danger"
              i="fas fa-times-circle"
              @click="cancel"
            >
              Cancelar
            </ActionButton>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import moment from 'moment';
import general from '@/services/pei/general';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import ActionButton from '@/components/common/ActionButton';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomFileInput from '@/components/common/CustomFileInput';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';

export default {
  name: 'AttachDocument',
  mixins: [mixAlert, mixWait],
  components: {
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    CustomDatePicker,
    ActionButton,
    CustomTextArea,
  },
  props: {
    get: Boolean,
    document: {
      type: Object,
      default: () => {},
    },
    editing: {
      type: Boolean,
      default: () => false,
    },
    types: {
      type: Array,
      default: () => [],
      required: true,
    },
    allowedFiles: {
      type: String,
      default: '*',
      required: true,
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
    columnsToShow: {
      type: Array,
      default: () => [],
    },
    commentMaxLength: {
      type: Number,
      default: () => 500,
    },
    canShowSave: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      errorMsgs: {
        document: 'Favor de anejar el documento.',
        date: 'Favor de entrar la fecha del documento.',
        comment: 'Favor de entrar el comentario.',
        errorOnSaving: 'Se ha producido un error al guardar el documento',
        missingFields: 'Se requiere completar todos los campos para continuar',
      },
      tempFileUpload: {
        files: [],
        types: [],
      },
      showUpload: false,
      showMessageDocumentType: false,
      showMessageDate: false,
      columns: [
        { title: 'Fecha', visible: true },
        { title: 'Tipo', visible: true },
        { title: 'Titulo', visible: true },
        { title: 'Comentario', visible: true },
      ],
    };
  },
  mounted() {
    if (this.columnsToShow.length > 0) {
      this.columns
        .filter((x) => !this.columnsToShow.includes(x.title))
        .map((x) => (x.visible = false));
    }
  },

  methods: {
    isVisible(column) {
      return this.columns.find((x) => x.title === column).visible;
    },
    cancel() {
      this.showMessageDocumentType = false;
      this.$emit('cancel');
    },
    enableEditing() {
      this.$emit('enableEditing');
    },
    getMessage(code) {
      return this.validationMessages.find((element) => element.id == code);
    },
    checkValidation() {
      let isValid =
        moment.isDate(this.document.date) &&
        this.document.attachment !== null &&
        this.document.comment !== '' &&
        Number(this.document.documentTypeId) > 0;

      let typeSelected = this.$refs['typeSelected'];
      this.showMessageDocumentType =
        isNaN(this.document.documentTypeId) ||
        this.document.documentTypeId == 0;

      typeSelected.style.backgroundColor =
        this.document.documentTypeId == 0 ? '#f7d7da' : '#fff';

      return isValid;
    },
    async save() {
      const isValid = await this.$refs.observer.validate();

      if (!this.checkValidation() || !isValid) return;

      this.$emit('save');
    },
    downloadFile(e) {
      let file = this.tempFileUpload.files[e.target.getAttribute('data-node')];
      general.documentDownloadLocalFile(file);
    },
  },
};
</script>

<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>
<style scoped>
.orange-icon {
  color: #ff7058;
}
.hidden {
  display: none;
}
.p-title {
  text-align: left;
  font-family: 'Lato';
  font-size: 16px;
}
.p-title.title-header {
  font-weight: bold;
}
.info > .center-box {
  float: left;
}
.danger-text {
  color: #e85c5c;
}
.actions {
  margin-top: 6rem !important;
}
</style>
